import * as React from 'react';
import { Box } from 'wix-style-react';
import { useReviewForm } from '../../hooks/useReviewForm';
import { ReviewAppHeader } from './review-app-header';
import { ReviewAppForm } from './review-app-form';
import { ReviewAppPageFooter } from './review-app-page-footer';
function ReviewAppPageContent(_a) {
    var appDefId = _a.appDefId, appReviewData = _a.appReviewData, onSuccessfulSubmission = _a.onSuccessfulSubmission, editorSdkVariant = _a.editorSdkVariant, t = _a.t;
    var _b = appReviewData || {}, appName = _b.appName, appIconSrc = _b.appIconSrc, previousReview = _b.previousReview;
    var reviewForm = useReviewForm(appDefId, previousReview, onSuccessfulSubmission);
    var headerMarginTop = editorSdkVariant ? '32px' : '36px';
    return (React.createElement(Box, { direction: "vertical", maxWidth: "600px" },
        React.createElement(Box, { marginTop: headerMarginTop, direction: "vertical" },
            React.createElement(ReviewAppHeader, { appName: appName, appIconSrc: appIconSrc, t: t })),
        React.createElement(Box, { marginTop: "18px", direction: "vertical" },
            React.createElement(ReviewAppForm, { appName: appName, reviewForm: reviewForm, editorSdkVariant: editorSdkVariant, t: t })),
        React.createElement(Box, { marginTop: "30px", direction: "vertical" },
            React.createElement(ReviewAppPageFooter, { onSubmitButtonClick: reviewForm.submit, t: t }))));
}
export { ReviewAppPageContent };
//# sourceMappingURL=review-app-page-content.js.map